<template>
    <div :class="$store.state.hideLogo && isMobile() ? 'left-area-mobile' : 'left-area-desktop'">
        <div class="symbol-logo" v-if="!$store.state.hideLogo">
            <img v-if="selectedSymbol?.symbolCode" :src="`${$store.state.cdnPath}/${selectedSymbol?.symbolCode}`" :alt="getSymbolAlt(selectedSymbol)" />
        </div>
        <v-select class="symbol-box" v-model="selectedSymbol" placeholder="Sembol Ara" :items="symbols" outlined append-icon="mdi-magnify"
            no-data-text="Sembol Bulunamadı!" @input="selectSymbol"
            attach>
            <template v-slot:prepend-item>
                <v-list-item>
                    <v-list-item-content>
                        <v-text-field v-model="searchText" label="Ara"
                            @input="searchSymbols" class="search-box"></v-text-field>
                    </v-list-item-content>
                </v-list-item>
                <v-divider class="mt-1"></v-divider>
            </template>
            <template v-slot:selection="{ item }">
                <div class="symbol-info">
                    <div>
                        <span class="desc">{{ item.description }}</span><br>
                        <span class="bist-code">{{ item.exchangeCode }}: {{ item.symbolCode }}</span>
                    </div>
                </div>
            </template>
            <template v-slot:item="{ item }">
                <img class="item-symbol-logo" :src="`${$store.state.cdnPath}/${item.symbolCode}`" :alt="getSymbolAlt(item)" />
                <span class="item-symbol-info">{{ item.symbolCode }} - {{ item.description }}</span>
            </template>
        </v-select>
        <div class="symbol-details">
            <slot name="items"></slot>
            <div class="button-area text-center">
                <div class="dropdown">
                    <button class="button" @click="$commonHelper.screenshot('InstagramPage', `${labelDefinition.projectTitle[$store.state.lang]} - ${selectedSymbol?.symbolCode}`);">
                        <span class="text">{{ labelDefinition.share[$store.state.lang] }}</span>
                    </button>
                </div>
                <button class="button" @click="$emit('export-pdf');" v-if="!isMobile()">
                    <span class="text">{{ labelDefinition.exportPdf[$store.state.lang] }}</span>
                </button>
            </div>
        </div>
    </div>
</template>
<script>

import definition from '../data-definition';
export default {
    name: 'LeftArea',
    props: {
        symbolCode: String
    },
    data() {
        return {
            selectedSymbol: {},
            allSymbols: [],
            symbols: [],
            searchText: '',
            shareToggle: false,
            labelDefinition: definition.labelDefinition
        }
    },
    mounted() {
        this.allSymbols = this.$store.state.symbols;
        this.symbols = this.allSymbols;
        this.findSymbol();
    },
    methods: {
        getSymbolAlt(symbol) {
            if (!symbol?.symbolCode) {
                return '';
            }
            return `${symbol.symbolCode} - ${symbol.description}`;
        },
        searchSymbols(text) {
            if (text) {
                this.symbols = this.allSymbols.filter(s => {
                    const searchText = text.toLowerCase();
                    const hasSymbolCode = s.symbolCode.toLowerCase().indexOf(searchText) !== -1;
                    const hasDescription = s.description.toLowerCase().indexOf(searchText) !== -1;

                    return hasSymbolCode || hasDescription;
                });
            } else {
                this.symbols = this.allSymbols;
            }
        },
        selectSymbol(symbol) {
            this.selectedSymbol = symbol;
            this.searchText = '';
            this.symbols = this.allSymbols;
            this.$emit('symbol-selected', this.selectedSymbol);
            this.setGtagEvent(symbol?.symbolCode);
        },
        toggleDropdown() {
            this.shareToggle = !this.shareToggle;
            document.querySelector('.dropdown-menu').style.display = this.shareToggle === true ? 'block' : 'none';
        },
        findSymbol() {
            this.selectedSymbol = this.allSymbols?.find(s => s.symbolCode === this.symbolCode);
            this.setGtagEvent(this.symbolCode);
        },
        isMobile() {
          return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
        setGtagEvent(symbol) {
            document.gtag('event', 'screen_view', {
              'app_name': 'MATRIKS TEMEL ANALİZ',
              'screen_name': symbol
            });
        }
    }
}
</script>
